import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsChoiceButtonGroup as ChoiceButtonGroup } from './src/index.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(ChoiceButtonGroup);
export const FsChoiceButtonGroup = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-choice-button-group.js.map